import React, { useEffect, useState } from "react";
import { makeShellT } from "./i18n/index.js";

/* Lightweight "Add to Home Screen" banner using the standard
   beforeinstallprompt event (Chromium/Android/desktop). Safari/iOS has no
   such event; those users install via the native share-sheet, so the
   banner simply never appears there — no unsupported-API errors. */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const t = makeShellT();

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!deferred || dismissed) return null;

  return (
    <div
      role="status"
      style={{
        position: "fixed",
        left: 12,
        right: 12,
        bottom: 12,
        zIndex: 80,
        maxWidth: 536,
        margin: "0 auto",
        background: "#1D2432",
        border: "1px solid #2A3242",
        borderRadius: 14,
        padding: "12px 14px",
        display: "flex",
        alignItems: "center",
        gap: 10,
        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
        fontFamily: "'Geist', system-ui, sans-serif",
      }}
    >
      <div style={{ flex: 1, color: "#F2ECDC", fontSize: 13 }}>{t("app.install.prompt")}</div>
      <button
        onClick={() => setDismissed(true)}
        style={{ background: "none", border: "none", color: "#9AA3B2", fontSize: 13, cursor: "pointer" }}
      >
        {t("app.install.dismiss")}
      </button>
      <button
        onClick={async () => {
          setDismissed(true);
          try {
            await deferred.prompt();
          } catch (err) {
            console.error("[Aurio] install prompt failed", err);
          }
        }}
        style={{
          background: "#C9A227",
          color: "#0E1118",
          border: "none",
          borderRadius: 8,
          padding: "6px 12px",
          fontWeight: 600,
          fontSize: 13,
          cursor: "pointer",
        }}
      >
        {t("app.install.action")}
      </button>
    </div>
  );
}
